import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { FormattedMessage } from 'react-intl';

// styles
import styles from './PdpRespSeoLinks.scss';

//helpers
import get from 'lodash.get';
import classnames from 'classnames';
import tracking from 'dibs-tracking';

const trackLinkClick = () => {
    tracking.trackEvent({
        category: 'product',
        action: 'more ways to browse link click',
    });
};

function PdpRespSeoLinksComponent({ item, viewer }) {
    const seoLinks = get(item, 'internalBuyLinks');
    const isEnabled = get(viewer, 'isMoreWaysToBrowseEnabled');

    if (!isEnabled || !seoLinks || !seoLinks.length) {
        return null;
    }

    return (
        <div>
            <h2 className={styles.header}>
                <FormattedMessage id="PdpRespSeoLinks.title" defaultMessage="More Ways to Browse" />
            </h2>
            <div data-tn="pdp-resp-seo-links" className={classnames(styles.links, 'rowFlex')}>
                {seoLinks.map(link => (
                    <div key={link.url} className={classnames(styles.link, 'colXs12 colMd4')}>
                        <a href={link.url} onClick={trackLinkClick}>
                            {link.anchorText}
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
}

PdpRespSeoLinksComponent.propTypes = {
    item: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
};

export const PdpRespSeoLinks = createFragmentContainer(PdpRespSeoLinksComponent, {
    viewer: graphql`
        fragment PdpRespSeoLinks_viewer on Viewer {
            isMoreWaysToBrowseEnabled: isEnabledByLocale(featureName: "MORE_WAYS_TO_BROWSE")
        }
    `,
    item: graphql`
        fragment PdpRespSeoLinks_item on Item {
            internalBuyLinks {
                anchorText
                url
            }
        }
    `,
});
